import React, { useState } from "react";



const AdminRedoTask = ({listOfRedo, openredomodal}) =>{
    const [filterOptions, setFilterOptions] = useState([false,false,false]);

    const clickOption = (index) =>{
        const resetFilterOptions = [false,false,false];
        resetFilterOptions[index] = true;
        setFilterOptions(resetFilterOptions);
    }

    return(
        <main className="dashboard-main">
            <div>
                <h2>Redo Tasks</h2>
            </div>
            <div>
                <button onClick={() =>  clickOption(0)}>Balance Sheet</button>
                <button onClick={() =>  clickOption(1)}>Income Sheet</button>
                <button onClick={() =>  clickOption(2)}>CashFlow Sheet</button>
            </div>

            <ul className="task-list">
                {listOfRedo && listOfRedo.map((task, index) => (
                <li key={index} className="task-item"  onClick={() => openredomodal(task)}>
                    <p>{task.stock_symbol}</p>
                    <p>{task.date_of_financial_data}</p>
                    <p>{task.type}</p>
                    <p>{task.financial_file_type}</p>

                </li>
                ))}
            </ul>
        </main>
    );
}

export default AdminRedoTask;